import { render, staticRenderFns } from "./YScroll.vue?vue&type=template&id=6922a7c4&scoped=true&"
import script from "./YScroll.vue?vue&type=script&lang=js&"
export * from "./YScroll.vue?vue&type=script&lang=js&"
import style0 from "./YScroll.vue?vue&type=style&index=0&id=6922a7c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6922a7c4",
  null
  
)

export default component.exports